import { render } from "./ResourceIcon.vue?vue&type=template&id=3ee3fbea"
import script from "./ResourceIcon.vue?vue&type=script&lang=js"
export * from "./ResourceIcon.vue?vue&type=script&lang=js"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__